import Button from '~/src/components/Button'
import LoaderIcon from '~/src/components/svg/LoaderIcon'
import RestyleIcon from '~/src/components/svg/RestyleIcon'
import { cn } from '~/src/lib/utils'

interface Props extends React.ComponentPropsWithoutRef<typeof Button> {
  onClick: () => void
  processing?: boolean
}

const RestyleUploadButton: React.FC<Props> = ({
  onClick,
  processing,
  className,
}) => {
  return (
    <Button
      className={cn(
        'inline-flex items-center gap-2.5 border-none bg-gradient-to-r from-[#B14CE7] to-[#295feb] px-10 transition-opacity md:hover:opacity-90',
        className
      )}
      rounded
      size='xl'
      variant='custom'
      onClick={onClick}
    >
      {processing ? (
        <div className='animate-spin'>
          <LoaderIcon height={20} />
        </div>
      ) : (
        <RestyleIcon className='h-5 w-5' />
      )}

      <div className='inline-flex gap-1'>
        <span className='hidden md:block'>Upload photo</span>
        <span className='block md:hidden'>Take photo</span>
      </div>
    </Button>
  )
}

export default RestyleUploadButton
